// The `field` values of a link's target, as authored in the link dialog (see demo-ftl-base's
// linkTarget.yaml and demo-ecommerce-base's linkTarget.yaml). Each is also the name of the
// property that holds the target's value: { field: "blog", blog: {...} }.
// ARTIFICIAL is not authored: it marks the links the SPA builds itself (see constructArtificialLinkNode).
export const LINK_TARGETS = {
    NONE: "none",
    EXTERNAL: "external",
    WEBSITE: "website",
    ARTIFICIAL: "artificial",
    ECOMMERCE_CATEGORIES: "ecommerce-categories",
    ECOMMERCE_PRODUCTS: "ecommerce-products",
    BLOG: "blog",
    EVENTS: "events",
    B2B_PROFILES: "b2b-profiles",
};
